import { createRouter, createWebHistory } from "vue-router";
import AdminLayout from "../layouts/AdminLayout.vue";
import LoginView from "../views/LoginView.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/login", name: "login", component: LoginView, meta: { public: true } },
    {
      path: "/",
      component: AdminLayout,
      children: [
        { path: "", redirect: "/dashboard" },
        { path: "dashboard", name: "dashboard", component: () => import("../views/DashboardView.vue") },
        { path: "appointments", name: "appointments", component: () => import("../views/AppointmentsView.vue") },
        { path: "services", name: "services", component: () => import("../views/ServicesView.vue") },
        { path: "company", name: "company", component: () => import("../views/CompanyView.vue") },
        { path: "system", name: "system", component: () => import("../views/SystemView.vue") }
      ]
    }
  ]
});

router.beforeEach((to) => {
  const hasToken = Boolean(localStorage.getItem("yma-admin-token"));
  if (!to.meta.public && !hasToken) return { name: "login", query: { redirect: to.fullPath } };
  if (to.name === "login" && hasToken) return { name: "dashboard" };
  return true;
});

window.addEventListener("yma:unauthorized", () => {
  if (router.currentRoute.value.name !== "login") void router.replace({ name: "login" });
});

export default router;
